import { httpClient } from 'app/api/http/http-client';
import { Contact } from './_models';

const sendMessage = async (body: Contact) => {
  return await httpClient.post('/LandingPage/ContactUs', body);
};

export { sendMessage };
